// extracted by mini-css-extract-plugin
export default {"projectionSelect":"ProjectionSelect_projectionSelect__sT4e6"};